import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './services/firebase';
import LoginScreen from './screens/LoginScreen';
import HomeScreen from './screens/HomeScreen';
import AgentDashboard from './screens/agent/AgentDashboard';
import AgentLogin from './screens/agent/AgentLogin';

function CustomerApp() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    return onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
  }, []);

  if (loading) return (
    <div style={{ backgroundColor: '#0f0f1a', minHeight: '100vh',
                  display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ color: '#6366f1', fontSize: '18px' }}>Loading...</div>
    </div>
  );

  if (!user) return <LoginScreen onLogin={(uid) => setUser({ uid })} />;

  return <HomeScreen userId={user.uid} />;
}
function AgentApp() {
  const [agentId, setAgentId] = useState(null);

  if (!agentId) {
    return <AgentLogin onLogin={(id) => setAgentId(id)} />;
  }

  return (
    <AgentDashboard
      agentId={agentId}
      onLogout={() => setAgentId(null)}
    />
  );
}
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/app" element={<CustomerApp />} />
        <Route path="/" element={<CustomerApp />} />
        <Route path="/agent" element={<AgentApp />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;